import { Reducer } from 'redux';
import { actions } from './constants';

export const initialState: unknown = { isOpen: false };

const reducer: Reducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.SET_MODAL_TOGGLE: {
      const clonedState = { ...state };

      clonedState.isOpen = action.isModalOpen;

      return clonedState;
    }

    default: {
      return state;
    }
  }
};

export { reducer as modalReducer };
